exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "\n\n.OrderConfirmPage_container_QpDYQ {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: column;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n      -ms-flex-align: center;\n          align-items: center;\n  padding: 0 2rem;\n}\n\n.OrderConfirmPage_helpText_3yciA {\n  text-align: center;\n  margin-bottom: 0;\n}\n\n.OrderConfirmPage_button_2wyE9 {\n  width: 20rem;\n  max-width: 80%;\n  margin-top: 1rem;\n  margin-bottom: 4rem;\n}\n", ""]);

// exports
exports.locals = {
	"container": "OrderConfirmPage_container_QpDYQ",
	"helpText": "OrderConfirmPage_helpText_3yciA",
	"button": "OrderConfirmPage_button_2wyE9"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"importLoaders":1,"localIdentName":"[name]_[local]_[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/containers/OrderConfirmPage/OrderConfirmPage.css
// module id = 1020
// module chunks = 0